import React,{useContext, Fragment} from "react";
import { AppTableColumnProps } from "./AppTableColumn";
import { Checkbox,Icon } from 'antd';
import {AppTableContext} from "./AppTableProvider"
import {AppLevel} from "qcc"
export interface AppTableHeaderProps {
	columns: AppTableColumnProps[];
	width?:number;
}

const getAllCheckValue = (dataList: any[])=> {
    let allCount = dataList.length
    if (allCount === 0) return 0;
    let checkedCount =  dataList.filter(e => e._table_checked).length;
    if (checkedCount === 0) return 0;
    if(allCount===checkedCount) return 1;
    return 2;
} 

export const AppTableHeader = (props:AppTableHeaderProps) =>{

	const {dataList,handleCheckAll} = useContext(AppTableContext)

	const width = props.width === -1 ? '100%':`${props.width}px`
	const columns = props.columns;
	const allSelectStatus = dataList? getAllCheckValue(dataList):0;

	const renderColumn = (column:AppTableColumnProps) =>{
		if(column.field === "_table_check_box"){
			return (<div>
						<Checkbox 
							indeterminate={allSelectStatus===2} 
							checked={allSelectStatus===1}  
							onChange={(e)=>{handleCheckAll(e.target.checked)}} 
							/>
					</div>)
		}

		if(column.expand){
			return (<div>
				{column.title || ''}
				{/* <AppLevel endNumber={3}/> */}
			</div>)
		}

		return column.title || '';
	}

	return (<table data-width = {props.width}
	cellPadding="0" cellSpacing="0" style={{ width }}>
				<colgroup>
				{columns.map((column: AppTableColumnProps, index:number)=>{
					if(column.width ===0){
						return <col key={`${index}_col`} />
					}else{
						return <col key={index} width={`${column.width}px`} />
					}
				})}
				</colgroup>
				<tbody>
					<tr className="app-table-header-tr">
						{columns.map((column: AppTableColumnProps, index:number) => {
							return (
								<td key={index} className="app-table-header-td">
									<div className="app-table-header-td-outer" column-index={index}>
									{renderColumn(column)}
									</div>
								</td>
							)
						})}
					</tr>
				</tbody>
		</table>)

}


// WEBPACK FOOTER //
// ./src/qcc/AppTable/AppTableHeader.tsx